<template>
  <Navbar title="Registro de envios" :class=" {'show': showNavbar}">
    <template v-slot:close>
      <div @click="$emit('close')" class="close">
        Cerrar
      </div>
    </template>
    <template v-slot:content>

      <span v-if="new Date().getHours() >= limitHour && new Date().getHours() > flexLimitHour" class="text-sm text-center bg-red-800 text-white py-2 px-4 rounded block mb-8">Tus pedidos serán enviados mañana, revisa la fecha de entrega.</span>
      <span v-else-if="new Date().getHours() >= limitHour && new Date().getHours() <= flexLimitHour" class="text-sm text-center bg-red-800 text-white py-2 px-4 rounded block mb-8">Tus pedidos serán enviados hoy, con tafira flex.</span>
      <span v-else-if="new Date().getHours() <= limitHour" class="text-sm text-center bg-red-800 text-white py-2 px-4 rounded block mb-8">Tus pedidos serán enviados hoy, con tafira regular.</span>

      <!--Highlight-->
      <div class="bg-secondary p-4 rounded mb-8 text-white">
        <span class="text-xs uppercase mb-2 block">Monto a pagar</span>
        <span v-if="!needInvoice" class="text-2xl font-semibold">{{
          Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'PEN'
          }).format(document.total)
          }}</span>
        <span v-else class="text-2xl font-semibold">
          {{
          Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'PEN'
          }).format(document.total * 1.18)
          }}
        </span>
      </div>
      <!--End-->
      <!--Terms-->
      <div class="text-sm flex gap-4 items-center mb-4">
        <input v-model="terms" type="checkbox" name="terms" id="terms">
        <label for="terms">Acepto que la tarifa de mis envíos puede variar.</label>
      </div>
      <!--End-->
      <!--Invoice-->
      <div class="text-sm flex gap-4 items-center mb-4">
        <input v-model="needInvoice" type="checkbox" name="needInvoice" id="needInvoice">
        <label for="needInvoice">Deseo factura.</label>
      </div>
      <!--End-->
      <!--Drop off order-->
      <div v-if="this.list.length === 1" class="text-sm flex gap-4 items-center mb-4">
        <input v-model="dropOffOrder" type="checkbox" name="dropOffOrder" id="dropOffOrder">
        <label for="needInvoice">Deseo dejar el pedido en almacén</label>
      </div>
      <!--End-->
      <!--WhatsApp-->
      <a
        :href="`https://api.whatsapp.com/send/?phone=51930910495&text=¡Hola!+Tengo+una+consulta+o+solicitud.+&type=phone_number&app_absent=0`"
        target="_blank"
        class="bg-[#25d366] text-white rounded flex items-center justify-center text-sm gap-4 px-4 py-2 mb-8">
        <whats-app-icon></whats-app-icon>
        <span>¿Deseas saber la tarifa exacta? Escríbenos</span>
      </a>
      <!---End--->
      <div v-if="terms">
        <!--Payment methods (Without Invoice)-->
        <div v-if="!needInvoice" class="border border-gray-500 bg-white border-dashed p-4 text-sm space-y-4 mb-8 whitespace-pre-line">
          <span v-html="convertStringToHTML(data.content.accounts)"></span>
        </div>
        <!--End-->
        <!--Payment methods (Invoice)-->
        <div v-else class="border border-gray-500 bg-white border-dashed p-4 text-sm space-y-4 mb-8 whitespace-pre-line">
          <span v-html="convertStringToHTML(data.content.invoiceAccounts)"></span>
        </div>
        <!--End-->
        <!--Observation-->
        <div class="mb-8">
          <div class="form-group">
            <label for="name">Observación</label>
            <input v-model="document.observation" class="input" type="text" id="name">
            <span v-if="this.validationErrors.observation" class="error">{{ this.validationErrors.observation }}</span>
          </div>
        </div>
        <!--End-->
        <!--Amount-->
        <div class="bg-secondary p-3 rounded text-white">
          <span class="text-xs uppercase mb-2 block">Monto detectado</span>
          <span class="text-xl font-semibold">{{
            Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'PEN'
            }).format(detectedAmount)
            }}</span>
        </div>
        <!--End-->
        <!--Alert-->
        <div v-if="validationWasDone && document.client.paymentMethod.value === 'Contado'"
             class="text-sm text-white mt-4">
          <span v-if="validationWasDone && detectedAmount > document.total " class="block bg-primary h-full w-full p-2 rounded">Los montos no coinciden, podrás enviar tu orden pero será previamente evaluada.</span>
          <span v-else-if="validationWasDone && detectedAmount < document.total" class="block bg-primary h-full w-full p-2 rounded">Los montos no coinciden, por favor revisa el comprobante.</span>
          <span v-else class="block bg-green-900 h-full w-full p-2 rounded">Los montos coinciden, gracias por el abono. Puedes realizar el envío.</span>
        </div>
        <!--End-->
        <!--Voucher-->
        <div class="form-group mt-8">
          <input @change="updateImage" class="file" ref="uploadVoucher" type="file" accept="image/*">
          <button :disabled="validateAmountIsLoading" :class=" {'is-loading': validateAmountIsLoading}"
                  class="btn btn--outline btn--w100" @click="$refs.uploadVoucher.click()">
            <span v-if="!validateAmountIsLoading">Adjuntar comprobante</span>
          </button>
          <img class="preview" v-if="attach" :src="preview" alt="Voucher">
        </div>
        <!--End-->
      </div>
    </template>
    <template v-slot:footer>
      <button
        :disabled="progress || !terms || validateAmountIsLoading || !validationWasDone || document.total > detectedAmount"
        :class=" {'is-loading': progress}" @click="save"
        class="btn">
        <span v-if="!progress">Enviar</span>
      </button>
    </template>
  </Navbar>
  <Shadow :class=" {'show': showNavbar}"/>
</template>

<script>
import Navbar from '../Navbar.vue'
import Shadow from '../Shadow.vue'
import moment from 'moment'
import axios from 'axios'
import * as yup from 'yup'
import general from '../../../mixins/general'

import { db, FieldValue, storage } from '@/firebase/firebaseConfig'
import WhatsAppIcon from '../atoms/icons/WhatsAppIcon.vue'

yup.setLocale({
  mixed: {
    required: 'Este campo es obligatorio'
  },
  number: {
    positive: 'Debe ser positivo',
    integer: 'Debe ser entero',
    truncate: 'Formato incorrecto'
  }
})

export default {
  name: 'Pay',
  components: {
    WhatsAppIcon,
    Navbar,
    Shadow
  },
  mixins: [general],
  props: {
    showNavbar: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    limitHour: {
      type: Number
    },
    flexLimitHour: {
      type: Number
    },
    hasError: {
      type: Boolean
    }
  },
  data () {
    return {
      document: {},
      detectedAmount: 0,
      validateAmountIsLoading: false,
      validationWasDone: false,
      progress: false,
      terms: false,
      needInvoice: false,
      dropOffOrder: false,
      validationErrors: {},
      attach: null,
      url: null,
      preview: '',
      moment: moment
    }
  },
  watch: {
    showNavbar (value) {
      if (value) {
        this.document = {
          ...this.data
        }

        if (!this.hasPlacedOrderToday()) {
          this.document.total = this.list.length === 1 ? this.document.total + 10 : this.document.total
        }

        this.terms = false
        this.needInvoice = false
        this.validationErrors = {}
        this.preview = ''
        this.attach = null
        this.validationWasDone = this.document.client.paymentMethod.value === 'Crédito'

        this.document.client.paymentMethod.value === 'Crédito' ? this.detectedAmount = this.document.total : this.detectedAmount = 0
      }
    },
    dropOffOrder (value) {
      if (value) {
        if (!this.hasPlacedOrderToday()) {
          this.document.total = this.document.total - 10
        }
      } else {
        if (!this.hasPlacedOrderToday()) {
          this.document.total = this.list.length === 1 ? this.document.total + 10 : this.document.total
        }
      }
    }
  },
  methods: {
    /**
     * Save data in firestore
     * */
    async save () {
      try {
        if (!this.hasError) {
          if (!this.progress && this.detectedAmount) {
            if (this.url || this.document.client.paymentMethod.value === 'Crédito') {
              this.progress = true
              this.validationErrors = {}

              this.document = this.normalizeObject(this.document)

              const obj = {
                ...this.document,
                voucher: this.url || '',
                observation: this.document.observation || '',
                createdAt: FieldValue.serverTimestamp(),
                amountsMatch: this.document.total === this.detectedAmount,
                detectedAmount: parseFloat(this.detectedAmount.toFixed(2)),
                needInvoice: this.needInvoice,
                dropOffOrder: this.dropOffOrder
              }

              // Save in order in firestore
              const orderDoc = await db.collection('orders').add({
                ...obj,
                quantityShipments: this.list.length
              })
              // End

              // Save detail
              const batch = db.batch()
              this.list.forEach((detail) => {
                detail = this.normalizeObject(detail)
                obj.client = this.normalizeObject(obj.client)
                const detailDocRef = db.collection('detail').doc()
                batch.set(detailDocRef, {
                  orderId: orderDoc.id,
                  clientId: obj.client.id,
                  client: obj.client,
                  ...detail,
                  pickUpDate: new Date(detail.pickUpDate + ' 05:00:00'),
                  deadline: new Date(detail.deadline + ' 05:00:00'),
                  createdAt: FieldValue.serverTimestamp(),
                  amountsMatch: this.document.total === this.detectedAmount,
                  status: 'hold'
                })
              })
              await batch.commit()
              // End
              this.markOrderToday()
              this.$emit('done')
            } else {
              this.$toast.error('Debes adjuntar el comprobante de pago')
            }
          }
        } else {
          this.$toast.error('Existen errores en tus envíos')
          this.$emit('close')
        }
      } catch (err) {
        this.$toast.error('Error al registrar pago')
      } finally {
        this.progress = false
      }
    },
    /**
     * Marker order today
     */
    markOrderToday () {
      const today = new Date().toDateString() // Example: "Thu Nov 06 2025"
      localStorage.setItem('orderDate', today)
    },
    // Function to check if the user already placed an order today
    hasPlacedOrderToday () {
      const today = new Date().toDateString()
      const savedDate = localStorage.getItem('orderDate')
      return savedDate === today
    },
    updateImage (input) {
      try {
        if (input.target.files && input.target.files[0]) {
          const reader = new FileReader()
          reader.onload = async e => {
            this.validateAmountIsLoading = true
            this.preview = e.target.result
            this.attach = input.target.files[0]
            this.url = await this.submitFile(this.attach)

            const response = await axios.post('https://us-central1-enwam-8794a.cloudfunctions.net/vision-validateVoucher', {
              imageUrl: this.url
            }, {})

            this.document.total = parseFloat(this.document.total.toFixed(2))
            this.detectedAmount = response.data.extractedAmount
            this.validateAmountIsLoading = false
            this.validationWasDone = true
          }
          reader.readAsDataURL(input.target.files[0])
        }
      } catch (e) {
        this.$toast.error('Error al cargar imagen')
        this.validateAmountIsLoading = false
      } finally {
        this.validateAmountIsLoading = false
      }
    },
    /**
     * Save doc in firebase storage
     * @param doc
     * @returns {Promise<unknown>}
     */
    submitFile (doc) {
      return new Promise((resolve, reject) => {
        this.validateAmountIsLoading = true
        const docName = Math.random().toString(36).substr(1, 20)
        const fileExtension = '.' + doc.name.split('.').pop()
        const docNameFinal = docName + fileExtension

        const storageRef = storage.ref(`vouchers/${docNameFinal}`)
        storageRef.put(doc)
          .then((snapshot) => {
            snapshot.ref.getDownloadURL().then(async (url) => {
              resolve(url)
            })
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * Delete undefined
     */
    normalizeObject (obj) {
      if (obj == null || typeof obj !== 'object') return obj

      const result = {}
      for (const key in obj) {
        if (Object.hasOwn(obj, key)) {
          const value = obj[key]
          result[key] = value === undefined ? '' : value
        }
      }
      return result
    }
  }
}
</script>
